module.exports = __webpack_public_path__ + "img/dne_app.7b287f10.png";